import { render, staticRenderFns } from "./box-input-site-button.vue?vue&type=template&id=7136626b&scoped=true&"
import script from "./box-input-site-button.vue?vue&type=script&lang=js&"
export * from "./box-input-site-button.vue?vue&type=script&lang=js&"
import style0 from "./box-input-site-button.vue?vue&type=style&index=0&id=7136626b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136626b",
  null
  
)

export default component.exports